import { render, staticRenderFns } from "./elevatorInfo.vue?vue&type=template&id=4cedc14d&scoped=true&"
import script from "./elevatorInfo.vue?vue&type=script&lang=js&"
export * from "./elevatorInfo.vue?vue&type=script&lang=js&"
import style0 from "./elevatorInfo.vue?vue&type=style&index=0&id=4cedc14d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cedc14d",
  null
  
)

export default component.exports